var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorehorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 11.5827C10.8748 11.5827 11.5837 10.8738 11.5837 9.99935C11.5837 9.1249 10.8748 8.41602 10.0003 8.41602C9.12587 8.41602 8.41699 9.1249 8.41699 9.99935C8.41699 10.8738 9.12587 11.5827 10.0003 11.5827Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 11.5827C16.7078 11.5827 17.4167 10.8738 17.4167 9.99935C17.4167 9.1249 16.7078 8.41602 15.8333 8.41602C14.9589 8.41602 14.25 9.1249 14.25 9.99935C14.25 10.8738 14.9589 11.5827 15.8333 11.5827Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 11.5827C5.04079 11.5827 5.74967 10.8738 5.74967 9.99935C5.74967 9.1249 5.04079 8.41602 4.16634 8.41602C3.29189 8.41602 2.58301 9.1249 2.58301 9.99935C2.58301 10.8738 3.29189 11.5827 4.16634 11.5827Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorehorizontal);
export default __webpack_public_path__ + "static/media/morehorizontal.93137aed64c089d0fb57649b33445155.svg";
export { ForwardRef as ReactComponent };